import { manualBillingConstants } from '../constants';

export function manualBillingReducers(state = {}, action) {
    switch (action.type) {
        // Reset Firebird Service
        
        case manualBillingConstants.resetFirebirdService_request:
            return {
                ...state,
                resetFirebirdService_requesting: true, resetFirebirdService_status: false,
                resetFirebirdService_errorMsg: []
            }
        case manualBillingConstants.resetFirebirdService_success:
            return {
                ...state,
                resetFirebirdService_requesting: false, resetFirebirdService_status: true,
            }
        case manualBillingConstants.resetFirebirdService_failure:
            return {
                ...state,
                resetFirebirdService_requesting: false, resetFirebirdService_status: false, 
                resetFirebirdService_errorMsg: [action?.error?.response?.data?.exceptionMessage]
            }

        default:
            return state;
    }
}